
import { mapActions } from 'vuex'
export default {
    components: {},

    data() {
        return {}
    },

    methods: {
        ...mapActions('modal', ['SHOW_INTRODUCTION']),
        modalOpen(flag) {
            this.SHOW_INTRODUCTION(flag)
        },
    },
}
